// Copyright (c) 2016 Deere & Company

import AlertMessages, {getDefaultState} from '../state/alert-messages';
import AlertMessage from '../state/alert-message';
import actions from '../actions-list';

const messageTypeMap = {
    error: 'errorMessages',
    info: 'infoMessages',
    success: 'successMessages',
    warning: 'warningMessages'
};

const createMessage = (messageType, state, message) =>
    AlertMessages.update(state, {
        [messageType]: {
            $set: [
                ...state[messageType],
                new AlertMessage({
                    message
                })
            ]
        }
    });

const deleteMessage = (messageType, state, message) =>
    AlertMessages.update(state, {
        [messageType]: {
            $set: state[messageType].filter(item =>
                item.message !== message
            )
        }
    });

const dismissMessages = (messageType, state) =>
    AlertMessages.update(state, {
        [messageType]: {
            $set: []
        }
    });

const createAlertMessage = (state, action) => {

    if (messageTypeMap[action.messageType]) {

        return createMessage(messageTypeMap[action.messageType], state, action.message);

    }

    return state;

};

const deleteAlertMessage = (state, action) => {

    if (messageTypeMap[action.messageType]) {

        return deleteMessage(messageTypeMap[action.messageType], state, action.message);

    }

    return state;

};

const dismissAlertMessages = (state, action) => {

    if (messageTypeMap[action.messageType]) {

        return dismissMessages(messageTypeMap[action.messageType], state);

    }

    return state;

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_ALERT_MESSAGE]: createAlertMessage,
        [actions.DELETE_ALERT_MESSAGE]: deleteAlertMessage,
        [actions.DISMISS_ALERT_MESSAGES]: dismissAlertMessages
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/shared/reducers/alert-messages.js